import React from 'react';

import {
	makeStyles,
	CircularProgress
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	loadingContainer: {
		display: "flex",
		justifyContent: "center",
		margin: theme.spacing(3)
	},

	loadingIndicator: {
		color: theme.palette.primary.main
	}
}));

function LoadingIndicator(props) {
	let classes = styles();

	return (
		<div className={classes.loadingContainer}>
			<CircularProgress className={classes.loadingIndicator} />
		</div>
	);
}

export default LoadingIndicator;
